import { reduxForm, SubmissionError } from "redux-form";

import * as actions from "../constants/actions";
import SigninForm from "../components/forms/SigninForm";

const onSubmit = (values, dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.signin({ values, resolve, reject }));
  }).catch(error => {
    throw new SubmissionError({ _error: error });
  });
};

export default reduxForm({
  form: "signin",
  onSubmit
})(SigninForm);



// WEBPACK FOOTER //
// ./src/containers/SigninForm.js